var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"text-center shrink",class:{
    'cancelled-banner': _vm.showAsCancelled,
    'information-banner': !_vm.showAsCancelled,
  },attrs:{"dense":"","no-gutters":""}},[_c('v-col',[(_vm.isFinal)?_c('span',[_vm._v(" Deze oproep is ingevuld")]):(_vm.isCancelled)?_c('span',[_vm._v(" Deze oproep is geannuleerd")]):(_vm.isShoutOutInThePast)?_c('span',[_vm._v(" Deze oproep is verstreken ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }